class Partials
  @with: (partial, callback) =>
    $(partial).each ->
      window.regulator.initialize(this).then callback
  @selector: (partialName) =>
    ".#{partialName.split('/').join('-')}"

module.exports = Partials